const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.8;

export const normalizeImages = (value) => {
  if (Array.isArray(value)) return value;
  if (value && value.image_data_url) return [value];
  return [];
};

// Resize to MAX_DIMENSION on the long edge, re-encode as JPEG to keep wkhtmltopdf reliable.
function resizeAndEncode(dataUrl, onDone) {
  const img = new Image();
  img.onload = () => {
    const { width, height } = img;
    const scale = Math.min(1, MAX_DIMENSION / Math.max(width, height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    onDone(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
  };
  // Fall back to the original data URL so the counter is always released.
  img.onerror = () => onDone(dataUrl);
  img.src = dataUrl;
}

// Reads, resizes, and JPEG-encodes each file, resolving to the encoded image list once done.
export const readAndEncodeImages = files => Promise.all(files.map(file => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = () => {
    resizeAndEncode(reader.result, (encodedUrl) => {
      resolve({
        id: `${file.name}_${file.lastModified}_${Math.random().toString(36).slice(2, 8)}`,
        file_name: file.name,
        content_type: 'image/jpeg',
        image_data_url: encodedUrl,
      });
    });
  };
  reader.onerror = () => resolve(null);
  reader.readAsDataURL(file);
}))).then(images => images.filter(Boolean));



// WEBPACK FOOTER //
// ./client/app/utils/imageUpload.js